import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';
import Gradient from '../../../UiComponents/Gradient/Gradient';
import ApproachSlider from '../../../UiComponents/ApproachSlider/ApproachSlider';

const AboutApproach = ({ approachData }) => {
  const langToggle = useLanguage;
  return (
    <section className="about-approach" data-scroll-section>
      <div className="content-wrapper">
        <div className="default-info__header">
          <span className="default-info__header-marker">
            {langToggle(approachData.marker_ua, approachData.marker_ru)}
          </span>
          <h2 className="default-info__header-title">
            {langToggle(approachData.title_ua, approachData.title_ru)}
          </h2>
        </div>
        <ApproachSlider items={approachData.items} />
        <div
          className="services-approach__gradient-wrapper"
          data-scroll=""
          data-scroll-speed="-2.5"
          data-scroll-delay="0.05"
        >
          <div className="services-approach__gradient-wrapper__owerflow">
            <Gradient />
          </div>
        </div>
      </div>
    </section>
  );
};

AboutApproach.propTypes = {
  approachData: PropTypes.object,
};

export default AboutApproach;
